var map = {
	"./Expand-all.svg": 8900,
	"./Group.svg": 99547,
	"./LogOut.svg": 18408,
	"./Popup-question.svg": 97977,
	"./Radio.svg": 11839,
	"./Reservation.svg": 28632,
	"./accident-button.svg": 25646,
	"./accordian-icon.svg": 74760,
	"./add-icon.svg": 98043,
	"./alert-circle.svg": 36777,
	"./alert-triangle-icon.svg": 32481,
	"./ap-ar-dark.svg": 36556,
	"./ap-ar.svg": 94423,
	"./approval -popup.svg": 37168,
	"./approve-icon.svg": 37097,
	"./archive-icon.svg": 14670,
	"./arrow-curve-left-up.svg": 99779,
	"./arrow-down-light.svg": 8229,
	"./arrow-down.svg": 30222,
	"./arrow-icon.svg": 70021,
	"./arrow-refresh-icon.svg": 82191,
	"./arrow-right.svg": 91720,
	"./arrows-up.svg": 40734,
	"./bank.svg": 91832,
	"./bell.svg": 47185,
	"./branch-icon.svg": 77028,
	"./bread_crumb.svg": 64364,
	"./bread_crumb_double.svg": 62180,
	"./calendar-01.svg": 98188,
	"./calendar-03.svg": 48782,
	"./calendar-icon.svg": 7522,
	"./calendar.svg": 81072,
	"./car-icon.svg": 61762,
	"./change-status.svg": 47533,
	"./charter-icon.svg": 25139,
	"./check-black-icon.svg": 67578,
	"./check-broken.svg": 7788,
	"./check-icon.svg": 90052,
	"./chevron-down-blue.svg": 28817,
	"./chevron-down.svg": 66688,
	"./chevron.svg": 29067,
	"./client-dark.svg": 76508,
	"./client-edit.svg": 22404,
	"./client-info-icon.svg": 17918,
	"./client.svg": 16487,
	"./clock-1-icon.svg": 7176,
	"./clock-2-icon.svg": 29729,
	"./clock-icon.svg": 47666,
	"./clock.svg": 95904,
	"./close-icon.svg": 2464,
	"./closed-popup.svg": 25351,
	"./column-vertical.svg": 5479,
	"./company-detail.svg": 35171,
	"./company-details.svg": 5514,
	"./company-profile-dark.svg": 94492,
	"./company-profile.svg": 72967,
	"./confirm-with-note-icon.svg": 74926,
	"./contract-icon-dark.svg": 42871,
	"./contract-icon.svg": 88526,
	"./cross-icon-light.svg": 23151,
	"./cross-icon.svg": 61719,
	"./cycle-icon.svg": 53746,
	"./dashboard-dark.svg": 45547,
	"./dashboard.svg": 99274,
	"./delete-category.svg": 34420,
	"./download-02.svg": 20001,
	"./download-icon.svg": 45804,
	"./driver-edit.svg": 96841,
	"./driver-info-icon.svg": 92501,
	"./driver-picture-dummy-1.svg": 63704,
	"./driver-picture-dummy.svg": 51754,
	"./driver-remove-x.svg": 29850,
	"./driver-vehicle.svg": 13607,
	"./dry-clean-button.svg": 61046,
	"./edit-button.svg": 75987,
	"./edit-panicle.svg": 23085,
	"./edit-pen-custom.svg": 6748,
	"./edit-pen.svg": 22040,
	"./escalation.svg": 3121,
	"./excel-icon.svg": 77615,
	"./exclamation-mark.svg": 64549,
	"./export-icon.svg": 26886,
	"./file-1-icon.svg": 8304,
	"./file-attach.svg": 39110,
	"./file-icon.svg": 78026,
	"./finance-icon-dark.svg": 57763,
	"./finance-icon.svg": 32402,
	"./form-builder.svg": 66546,
	"./funnel-simple.svg": 36097,
	"./grid-icon.svg": 66924,
	"./image-icon.svg": 6197,
	"./image-placeholder.svg": 57581,
	"./information-circle-blue.svg": 64762,
	"./insurance-button.svg": 83371,
	"./license-renewal-button.svg": 49729,
	"./list-icon.svg": 71680,
	"./location-icon.svg": 34723,
	"./maintenance-Button.svg": 91728,
	"./maintenance-vector.svg": 62993,
	"./management-system.svg": 94227,
	"./map.svg": 9352,
	"./message-square.svg": 83917,
	"./messaging-center-icon-light.svg": 75721,
	"./messaging-center-icon.svg": 15410,
	"./minus-circle-contained.svg": 17695,
	"./mobile-map-dropoff-marker.svg": 88959,
	"./mobile-map-pickup-marker.svg": 49045,
	"./more-details.svg": 98652,
	"./move.svg": 79993,
	"./my-profile-dark.svg": 17717,
	"./my-profile.svg": 3080,
	"./new-list-icon.svg": 85929,
	"./operations.svg": 6064,
	"./paperclip-files.svg": 22604,
	"./pdf-icon.svg": 88902,
	"./person-vector.svg": 9323,
	"./phone-call.svg": 88231,
	"./pin-marker.svg": 94222,
	"./pincle-edit-light.svg": 84175,
	"./pincle-edit.svg": 86276,
	"./placeholder-add.svg": 86915,
	"./placeholder-location.svg": 16363,
	"./plus-danger.svg": 26946,
	"./plus-icon.svg": 26024,
	"./plus-secondary.svg": 30419,
	"./plus-white.svg": 70586,
	"./plus.svg": 68718,
	"./popup-cancel-icon.svg": 40071,
	"./popup-close.svg": 49599,
	"./popup-info-wide-icon.svg": 34592,
	"./popup-success-icon-new.svg": 5213,
	"./popup-success-icon.svg": 35288,
	"./popup-warning-icon.svg": 12391,
	"./printer.svg": 65006,
	"./privacy-page/auto-conversations.svg": 4431,
	"./privacy-page/call.svg": 59797,
	"./privacy-page/check.svg": 20851,
	"./privacy-page/clock.svg": 5361,
	"./privacy-page/db.svg": 36619,
	"./privacy-page/email.svg": 20223,
	"./privacy-page/list-one.svg": 78426,
	"./privacy-page/list-two.svg": 13892,
	"./privacy-page/security-check.svg": 11116,
	"./privacy-page/shield.svg": 71874,
	"./privacy-page/user-list.svg": 62705,
	"./recurrence-icon.svg": 4502,
	"./rejected-icon.svg": 18694,
	"./renewal-Button.svg": 17031,
	"./requests-icon-dark.svg": 60755,
	"./requests-icon.svg": 9026,
	"./returned-icon.svg": 69047,
	"./sales-icon-dark.svg": 29277,
	"./sales-icon-light.svg": 80107,
	"./search-bar-icon.svg": 32700,
	"./search-color-icon.svg": 13934,
	"./search-icon.svg": 44164,
	"./select-time.svg": 92664,
	"./setting-icon-dark.svg": 20589,
	"./setting-icon-light.svg": 78491,
	"./setting-icon.svg": 79280,
	"./shift-recurring-icon.svg": 12182,
	"./small-face-dark.svg": 36712,
	"./small-face.svg": 48507,
	"./small-truck.svg": 56561,
	"./sort-ascending.svg": 57663,
	"./sort-descending.svg": 38949,
	"./star.svg": 35034,
	"./start-marker.svg": 40937,
	"./step-shape.svg": 48620,
	"./switch-dark.svg": 18595,
	"./switch-outline.svg": 26123,
	"./system-management-dark.svg": 57900,
	"./tanker2.svg": 92947,
	"./ticket-button.svg": 57483,
	"./ticket-timer.svg": 76830,
	"./tickets-person.svg": 4189,
	"./tickets-timer-circle.svg": 68414,
	"./transfer-button.svg": 58668,
	"./trash-icon-red.svg": 14460,
	"./trash-icon.svg": 13158,
	"./trash-light-new.svg": 19314,
	"./trash-red-icon.svg": 36048,
	"./truck-icon.svg": 83551,
	"./trush-light.svg": 83523,
	"./trush.svg": 19320,
	"./upload-icon.svg": 1621,
	"./user-icon.svg": 45279,
	"./user-profile.svg": 86251,
	"./vehicle-picture-dummy.svg": 71368,
	"./warning-alert.svg": 81451,
	"./x-circle-contained.svg": 90503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89542;